<template>
  <div>
            <v-card-text>
              <v-alert
                :value="true"
                color="warning"
                icon="priority_high"
                outline
              >
                To Facility existed in Healthmark system already, use PICK FACILITY button to find. 
                To new Customer/Facility does not exist yet, just enter Facility data manually
              </v-alert>
              <v-layout>
                  <v-flex xs6 sm2 pa-1>
                        <v-text-field
                        v-model="quoteData.basicInfo.facilityAcctNo"
                        label="Facility #"
                        hint
                        persistent-hint
                        disabled
                        ></v-text-field>

                  </v-flex>
                  <v-flex xs6 sm3 pa-1>
                    <v-btn color="primary" v-show="isNewQuote" dark @click.prevent="showFacilityPicker = true">
                    <v-icon></v-icon>Pick Facility
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 sm7 pl->
                    <v-text-field
                      :rules="[rules.required]"
                      v-model="quoteData.basicInfo.facilityName"
                      label="Facility Name *"
                      hint
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout v-show="showSoldToDropdown">
                <v-flex xs12 md6 pa-1>
                    <v-select
                    :rules="soldToRequiredRules"
                    :items="soldToList"
                    :item-text="soldToDisplayText"
                    item-value="id"
                    return-object
                    v-model="quoteData.basicInfo.selectedSoldTo"
                    label="Customer *"
                    hint="Select the customer account for this quote"
                    persistent-hint
                    @change="onSoldToChanged"
                    ></v-select>
                </v-flex>
                <v-flex xs12 md6 pa-1>
                      <v-text-field
                      v-model="quoteData.basicInfo.customerClass"
                      label="Customer Class"
                      hint
                      persistent-hint
                      disabled
                      ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 pa-1>
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="quoteData.basicInfo.facilityAddress2"
                    label="Address 1 *"
                    hint
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm4>
                  <v-text-field
                    v-model="quoteData.basicInfo.facilityAddress3"
                    label="Address 2"
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex> -->
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 md4 pa-1>
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="quoteData.basicInfo.facilityCity"
                    label="City "
                    hint
                    persistent-hint
                  ></v-text-field>
                  
                </v-flex>
                <v-flex xs6 md2 pa-1>
                  <v-text-field
                    :rules="addressRequired"
                    v-model="quoteData.basicInfo.facilityState"
                    label="State "
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex>
                <v-flex xs6 md2 pa-1>
                  <v-text-field
                    :rules="addressRequired"
                    v-model="quoteData.basicInfo.facilityZip"
                    label="ZIP "
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex>
                <v-flex xs6 md4 pa-1>
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="quoteData.basicInfo.facilityCountry"
                    label="Country *"
                    hint
                    persistent-hint
                  >
                  </v-text-field>
                    <!-- <v-select
                    :rules="[rules.required]"
                    :items="allCountries"
                    item-text="name"
                    item-value="id"
                    
                    v-model="quoteData.basicInfo.facilityCountry"
                    label="Country"
                    hint=""
                    persistent-hint
                    cache-items
                    browser-autocomplete
                    ></v-select> -->
                </v-flex>

              </v-layout>
              <v-layout wrap>
                <v-flex xs8 sm4 pa-1>
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="quoteData.basicInfo.contactName"
                    label="Contact Name *"
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex>
                <v-flex xs4 sm2>
                  <v-btn color="primary" dark @click.prevent="showContactPicker=true">
                    Pick
                  </v-btn>
                </v-flex>
                <v-flex xs6 sm3 pa-1>
                  <v-text-field
                    v-model="quoteData.basicInfo.title"
                    label="Title"
                    maxlength = "50"
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex>
                <v-flex xs6 sm3 pa-1>
                  <v-text-field
                    v-model="quoteData.basicInfo.department"
                    label="Department"
                    maxlength = "150"
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 pa-1>
                  <v-text-field
                    :rules="[rules.required, rules.max21Chars]"
                    v-model="quoteData.basicInfo.phone"
                    maxlength = "100"
                    label="Phone *"
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex>
                <v-flex xs12 sm6 pa-1>
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="quoteData.basicInfo.email"
                    label="Email *"
                    hint
                    persistent-hint
                  ></v-text-field>

                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6 pa-1>
                    <v-select
                    :rules="termRequiredRules"
                    :items="terms"
                    item-text="name"
                    item-value="id"
                    return-object
                    v-model="quoteData.basicInfo.facilityPaymentType"
                    label="Terms"
                    hint="Payment Term of this Quote"
                    persistent-hint
                    ></v-select>
                </v-flex>
                <v-flex xs12 md6 pa-1>
                    <v-select
                    :rules="termRequiredRules"
                    :items="shippingMethods"
                    item-text="value"
                    item-value="key"
                    return-object
                    v-model="quoteData.basicInfo.facilityShipMethod"
                    label="Freight"
                    hint="Ship Method of this Quote"
                    persistent-hint
                    ></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout>
                      <v-flex xs4 pa-1>
                            <v-text-field
                            :rules="[rules.required]"
                            v-model="quoteData.basicInfo.facilityTerritory"
                            label="Territory"
                            hint
                            persistent-hint
                            disabled
                            ></v-text-field>

                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" v-show="couldPickTerr" dark @click.prevent="onShowTerrPicker">
                        <v-icon></v-icon>Pick Territory
                        </v-btn>
                      </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6 pa-1>
                    <v-select
                    :rules="salesRepRules"
                    :items="allActiveSalesReps"
                    item-text="name"
                    item-value="id"
                    return-object
                    v-model="quoteData.basicInfo.salesRep"
                    label="Sales Reps"
                    hint="Sales Reps of this Quote"
                    persistent-hint
                    ></v-select>
                </v-flex>
                <v-flex xs12 md6 pa-1>
                    <v-select
                    :rules="[rules.required]"
                    :items="allActiveCsReps"
                    item-text="name"
                    item-value="id"
                    return-object
                    v-model="quoteData.basicInfo.csRep"
                    label="Cust. Serv. Reps"
                    hint="Customer Service Reps of this Quote"
                    persistent-hint
                    ></v-select>
                </v-flex>
                <v-flex xs12 md6 pa-1>
                    <v-select
                    :rules="[rules.required]"
                    :items="allActiveIsReps"
                    item-text="name"
                    item-value="id"
                    return-object
                    v-model="quoteData.basicInfo.isRep"
                    label="Inside Sales Reps"
                    hint="Inside Sales Reps of this Quote"
                    persistent-hint
                    ></v-select>
                </v-flex>
                <v-flex xs12 md3 pa-1>
                  <!-- <v-text-field 
                    v-model="quoteData.basicInfo.quoteDate" 
                    label="Quote Date" 
                    placeholder="mm/dd/yyyy"
                  ></v-text-field> -->
                  <v-menu
                    v-model="quoteDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="quoteData.basicInfo.quoteDate"
                      label="Quote Date"
                      hint="yyyy-mm-dd"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="quoteData.basicInfo.quoteDate" @input="quoteDateMenu = false" 
                      no-title ></v-date-picker>
                  </v-menu>
            
                  <!-- <v-text-field
                    slot="activator"
                    v-model="quoteData.basicInfo.quoteDate"
                    label="Date"
                    hint=""
                    persistent-hint
                    prepend-icon="event"
                    @blur="date = parseDate(dateFormatted)"
                  ></v-text-field>
                  <v-date-picker v-model="quoteData.basicInfo.quoteDate" no-title ></v-date-picker> -->
                </v-flex>
                <v-flex xs6 md3 pa-1>
                    <v-select
                    :rules="[rules.required]"
                    :items="quoteExpireMonths"
                    item-text="name"
                    item-value="id"
                    v-model="quoteData.basicInfo.quoteExpirationMonths"
                    label="Expried After "
                    hint=""
                    persistent-hint
                    ></v-select>
                </v-flex>
                <v-flex xs6 md3 pa-1>
                  <v-menu
                    v-model="quoteExpDateMenu"
                    v-show="showQuoteExpDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                  <v-text-field
                    slot="activator"
                    v-model="quoteData.basicInfo.quoteExpirationDate"
                    label="Quote Expire Date"
                    hint="yyyy-mm-dd"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="quoteData.basicInfo.quoteExpirationDate" @input="quoteExpDateMenu = false" 
                    no-title ></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex xs12 md3 pa-1 v-show="customerAcctNumExists">
                  <v-checkbox
                    v-model="quoteData.basicInfo.hideTotalAmtInPdf"
                    label="Hide Total Amount in Pdf Quote"
                    data-vv-name="checkbox"
                    type="checkbox"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm5 pa-1 v-show="!customerAcctNumExists">
                  <v-select
                    :rules="gpoAffilRequiredRules"
                    :items="gpoList"
                    item-text="name"
                    item-value="id"
                    v-model="quoteData.basicInfo.gpoAffiliated"
                    label="GPO Affiliated"
                    hint=""
                    persistent-hint
                    ></v-select>
                </v-flex>
                <v-flex xs12 pa-1>
                  <v-textarea
                    label="Special Instruction"
                    rows="3"
                    counter="300"
                    maxlength="300"
                    v-model="quoteData.basicInfo.notes"
                    hint="For Custom Quote, please enter anything you would like the customer to see on the quote.  An example would be minimum order quantity."
                    persistent-hint
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 pa-1>
                  <v-textarea
                    label="Freight Information"
                    rows="3"
                    counter="300"
                    maxlength="300"
                    v-model="quoteData.basicInfo.freightInfo"
                    hint=""
                    persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
          </v-card-text>
      <v-dialog v-model="showFacilityPicker" width="500" height="400">
        <ctlFacilitySearch @onPicked="onFacilityPicked"></ctlFacilitySearch>
      </v-dialog>
      <v-dialog v-model="showTerrPicker" width="500" height="400">
        <ctlTerritoryXRepPicker :terrs="terrsForPicker" 
          @hide-territoryxrep-picker="hideTerritoryxrepPicker"
          @on-terr-picked="onTerrPicked"></ctlTerritoryXRepPicker>
      </v-dialog>
      <v-dialog v-model="showContactPicker" width="400" height="400">
        <ctlContactPicker :facilityId="quoteData.basicInfo.facilityId"
          @onContactPicked="onContactPicked"
          @onCloseContactPicker="showContactPicker=false"></ctlContactPicker>
      </v-dialog>
      <!-- {{quoteData}} -->
  </div>
</template>
<script>
import ctlFacilitySearch from "@/components/ctlFacilitySearch";
import ctlContactPicker from "@/components/ctlContactPicker";
import ctlTerritoryXRepPicker from "@/components/ctlTerritoryXRepPicker";
import { mapGetters, mapActions } from "vuex";

export default {
  props: ['quoteData'],
  components: {
    // 'ctlCustomerPicker' : ctlCustomerPicker,
    ctlFacilitySearch: ctlFacilitySearch,
    ctlContactPicker,
    ctlTerritoryXRepPicker,
  },
  data: () => ({
    // quoteData: {},
    terms: [],
    shippingMethods: [],
    allActiveSalesReps: [],
    allActiveCsReps: [],
    allActiveIsReps: [],
    // allCountries: [],
    quoteExpireMonths: [],
    // quoteExpireMonths: [
    //   {id: 1, name: 'End of Month'},
    //   {id: 3, name: '3 Months'},
    //   {id: 6, name: '6 Months'},
    //   {id: 12, name: '1 Year'},
    //   {id: 24, name: '2 Years'},
    //   {id: -1, name: 'Pick A Date'},
    // ],
    gpoList: [
      {id: "ASC – GP Premier", name: 'ASC – GP Premier'},
      {id: "ASC – Healthtrust", name: 'ASC – Healthtrust'},
      {id: "ASC – Vizient", name: 'ASC – Vizient'},
      {id: "ASC – The Resource Group/Ascension", name: 'ASC – The Resource Group/Ascension'},
      {id: "ASC – Kaiser", name: 'ASC – Kaiser'},
      {id: "ASC- Intalere", name: 'ASC- Intalere'},
      {id: "ASC – Non GPO", name: 'ASC – Non GPO'},
    ],
    showFacilityPicker: false,
    showContactPicker: false,
    quoteDateMenu: false,
    quoteExpDateMenu: false,
    // data to territory picker
    showTerrPicker: false,
    terrsForPicker: [],

    // SoldTo data
    soldToList: [],
    loadingSoldTo: false,

    formValid: false,
    rules: {
      required: v => !!v || "This field is required",
      max21Chars: v => (!!v && v.length < 100) || "Must be 100 or less Characters"
    }
  }),
  computed: {
    ...mapGetters("auth", [
        'userHasInternalRole',
        ]),

    salesRepRules () {
      // return this.quoteData.facilityAcctNo? [this.rules.required] : []
      return [this.rules.required]
    },
    termRequiredRules () {
      return this.customerAcctNumExists? [this.rules.required] : []
    },
    gpoAffilRequiredRules () {
      return this.customerAcctNumExists? [] : [this.rules.required]
    },
    customerAcctNumExists() {
      return this.quoteData.basicInfo && this.quoteData.basicInfo.facilityAcctNo
    },
    isNewQuote () {
      return !this.quoteData.id
    },
    addressRequired () {
      // if (this.quoteData.basicInfo == null) {
      //   return []
      // }

      // return this.quoteData.basicInfo.facilityCountry === 'USA'? [this.rules.required] : []
      //20200618 per Chris, we do not force user to maintain address after we add country field
      return []
    },
    couldPickTerr() {
      return this.quoteData && !this.quoteData.basicInfo.facilityAcctNo
    },
    couldChangePriceLevel() {
      return this.userHasInternalRole
    },
    showQuoteExpDateMenu() {
      return this.quoteData.basicInfo && this.quoteData.basicInfo.quoteExpirationMonths == -1
    },

    // SoldTo computed properties
    showSoldToDropdown() {
      // Show dropdown when facility exists (has account number) and SoldTo list is loaded
      return this.customerAcctNumExists && this.soldToList.length > 0
    },
    soldToRequiredRules() {
      // SoldTo is required when facility exists (has account number)
      return this.customerAcctNumExists ? [this.rules.required] : []
    },
    soldToDisplayText() {
      // Format display as "code / name"
      return (item) => {
        if (!item) return ''
        return `${item.code} / ${item.name}`
      }
    }
  },
  watch: {
    // Watch for facilityAcctNo changes - this fires when parent loads data
    'quoteData.basicInfo.facilityAcctNo': {
      immediate: true,
      handler: async function(newVal, oldVal) {
        console.log('watch facilityAcctNo changed:', oldVal, '->', newVal)
        if (newVal && newVal !== oldVal) {
          await this.loadSoldToListByAcctNo()
        }
      }
    }
  },
  methods: {
      ...mapActions('customerSearch', [
          'getFacilityDataById',
          'getFacilityByKeyWord',
      ]),
      ...mapActions('pubQuoteEdit', [
          'populateQuoteEditLookups',
          'getSoldToListByFacility',
      ]),

      ...mapActions('tazApi',[
          'searchRepsForWebQuote'
      ]),

      ...mapActions('adminMarket',[
          'getActiveTerritoriesSimpleData'
      ]),

    async onShowTerrPicker() {
      if (this.quoteData.basicInfo.facilityCountry == "USA" && !this.quoteData.basicInfo.facilityZip) {
        alert('Please enter ZIP code first!')
        return
      }

      if (this.quoteData.basicInfo.facilityCountry == "USA") {
        console.log(`'get rep and terr from taz for zip ${this.quoteData.basicInfo.facilityZip}'`)
        const searchCriteria = {zip: this.quoteData.basicInfo.facilityZip}
        const terrXreps = await this.searchRepsForWebQuote(searchCriteria)
        //transfer data format
        // this.terrsForPicker = [...new Set(terrXreps.map(item=>{return {id: item.territoryId, salesReps: []}}))]
        //special rule: 20210201, special rule: always add 500 here per Stephanie
        this.terrsForPicker = [...terrXreps.map(item=>{return {id: item.territoryId, salesReps: []}}), {id: '500', salesReps: []}]

      }
      // it is possible we cannot find out territory based on zip code
      // the reason could be 1. customer in some zips were hard splitted in TAZ, e.g. 02115 (BOSTON)
      // or 2. wrong zip
      // if so, we will get all territory list from webquote
      if(!this.terrsForPicker || !this.terrsForPicker.length) {
        console.log(`'get ALL terrs from webquote'`)
        const allTerrs = await this.getActiveTerritoriesSimpleData()
        //transfer data format
        this.terrsForPicker = allTerrs.map(item=>{return {id: item.id, salesReps: []}})

      }
                                        
      this.showTerrPicker = true
    },
    // get the quote lookup data based on facility id
    async getQuoteLookups (facilityIdAndTerritoryIdPayload) {
        var allLookups = await this.populateQuoteEditLookups(facilityIdAndTerritoryIdPayload)
        this.terms = allLookups.terms
        this.shippingMethods = allLookups.shippingMethods
        this.allActiveSalesReps = allLookups.allActiveSalesReps
        this.allActiveCsReps = allLookups.allActiveCsReps
        this.allActiveIsReps = allLookups.allActiveIsReps
        this.quoteExpireMonths = allLookups.quoteExpirationDatePrefefinedList
        // this.allCountries = allLookups.allCountries

    },
    // async populateRepsLookup(territoryId) {
            
    //   if(facilityData.facilityTerritory) {
    //     var terrData = await this.populateTerritoryEditModel(facilityData.facilityTerritory)

    //     if(!terrData.salesReps) {

    //     }
    //   }
    // },
    //payoad here is {id:id, terrId: terrId}
    async onFacilityPicked(payload) {
      console.log(`"onFacilityPicked, id=${payload.id}, terrId='${payload.terrId}'"`);
      this.showFacilityPicker = false
      // if close button in facility picker click, it also call this function.
      // just no id passed in, so need handle here
      if(!payload.id) {
        return
      }
      var facilityData = await this.getFacilityDataById(payload)
            // console.log('facilityData.facilityTerritory:' + facilityData.facilityTerritory)

      await this.getQuoteLookups(payload)

      // Load SoldTo list for this facility
      await this.loadSoldToList(payload.id)

      this.quoteData.basicInfo = Object.assign({}, this.quoteData.basicInfo, facilityData)

    },
    onContactPicked(contact) {
      var quoteContact = {
            contactId : contact.id,
            contactName : contact.name,
            department : contact.dept,
            title : contact.title,
            phone : contact.phone,
            email : contact.email,

      }
      this.quoteData.basicInfo = Object.assign({}, this.quoteData.basicInfo, quoteContact)
      this.showContactPicker = false
    },
    onTerrPicked(terrId) {
      // console.log(terrId)
        this.quoteData.basicInfo = Object.assign({}, this.quoteData.basicInfo, {facilityTerritory: terrId})
        this.showTerrPicker = false
        this.terrsForPicker = []
    },
    hideTerritoryxrepPicker() {
        this.showTerrPicker = false
        this.terrsForPicker = []
    },

    // SoldTo Methods
    // Note: This method only loads the list from API. It does NOT clear existing quote SoldTo data.
    // The caller (loadSoldToListByAcctNo) is responsible for handling selection and fallback logic.
    async loadSoldToList(facilityId) {
      console.log('loadSoldToList called with facilityId:', facilityId)
      if (!facilityId) {
        this.soldToList = []
        return
      }

      try {
        this.loadingSoldTo = true
        const soldToList = await this.getSoldToListByFacility(facilityId)
        console.log('SoldTo API response:', soldToList)
        this.soldToList = soldToList || []
        console.log('soldToList length:', this.soldToList.length)
      }
      catch (err) {
        console.error('Error loading SoldTo list:', err)
        this.soldToList = []
      }
      finally {
        this.loadingSoldTo = false
      }
    },

    assignSoldTo(soldTo) {
      if (!soldTo) return

      // Find the matching object from soldToList to ensure Vue reactivity works with v-select
      // v-select with return-object requires the exact object reference from the items array
      const matchedSoldTo = this.soldToList.find(s => s.id === soldTo.id) || soldTo

      // Use $set to ensure Vue reactivity detects the change on nested prop object
      this.$set(this.quoteData.basicInfo, 'selectedSoldTo', matchedSoldTo)
      this.$set(this.quoteData.basicInfo, 'soldToId', soldTo.id)
      this.$set(this.quoteData.basicInfo, 'soldToName', soldTo.name)
      this.$set(this.quoteData.basicInfo, 'soldToCode', soldTo.code)
      this.$set(this.quoteData.basicInfo, 'customerClass', soldTo.customerClass)

      console.log(`SoldTo assigned: ${soldTo.code} / ${soldTo.name}`)
    },

    onSoldToChanged(soldTo) {
      this.assignSoldTo(soldTo)
    },

    // Load SoldTo list when facilityAcctNo becomes available (called by watcher)
    async loadSoldToListByAcctNo() {
      console.log('loadSoldToListByAcctNo called')

      // Save existing quote SoldTo data BEFORE loading (in case API returns empty)
      const existingSoldToId = this.quoteData.basicInfo.soldToId
      const existingSoldToCode = this.quoteData.basicInfo.soldToCode
      const existingSoldToName = this.quoteData.basicInfo.soldToName
      console.log('Existing quote SoldTo:', existingSoldToId, existingSoldToCode, existingSoldToName)

      // First try to use existing facilityId
      let facilityIdToUse = this.quoteData.basicInfo.facilityId

      // If no facilityId but have account number, look up the facility
      if (!facilityIdToUse && this.quoteData.basicInfo.facilityAcctNo) {
        console.log('Looking up facility by account number:', this.quoteData.basicInfo.facilityAcctNo)
        try {
          const facilities = await this.getFacilityByKeyWord({keyword: this.quoteData.basicInfo.facilityAcctNo})
          if (facilities && facilities.length > 0) {
            // Find exact match by account number
            const matchedFacility = facilities.find(f => f.acctNo === this.quoteData.basicInfo.facilityAcctNo)
            if (matchedFacility) {
              facilityIdToUse = matchedFacility.id
              // Also update the basicInfo with the facilityId
              this.quoteData.basicInfo.facilityId = matchedFacility.id
              console.log('Found facility by account number, id:', facilityIdToUse)
            }
          }
        } catch (err) {
          console.error('Error looking up facility:', err)
        }
      }

      if (facilityIdToUse) {
        await this.loadSoldToList(facilityIdToUse)

        // If quote already has a SoldTo assigned, check if it exists in the list
        if (existingSoldToId) {
          const selectedSoldTo = this.soldToList.find(
            s => s.id === existingSoldToId
          )
          if (selectedSoldTo) {
            // SoldTo found in list, pre-select it using $set for Vue reactivity
            this.$set(this.quoteData.basicInfo, 'selectedSoldTo', selectedSoldTo)
            console.log('Pre-selected existing SoldTo from list:', selectedSoldTo)
          } else {
            // SoldTo NOT found in API response (relationship may have been removed)
            // Append the quote's existing SoldTo to the dropdown list
            console.log('Quote SoldTo not found in API response, appending from quote data')
            const quoteSoldTo = {
              id: existingSoldToId,
              code: existingSoldToCode,
              name: existingSoldToName
            }
            this.soldToList.push(quoteSoldTo)
            this.$set(this.quoteData.basicInfo, 'selectedSoldTo', quoteSoldTo)
            console.log('Appended quote SoldTo:', quoteSoldTo)
          }
        } else if (this.soldToList.length === 1) {
          // Auto-assign if only 1 SoldTo exists and no existing selection
          this.assignSoldTo(this.soldToList[0])
        }
      } else {
        console.log('No facilityId available, cannot load SoldTo list')
        // If no facility but quote has SoldTo data, create dropdown with just that SoldTo
        if (existingSoldToId && existingSoldToName) {
          console.log('Creating dropdown with quote SoldTo only')
          const quoteSoldTo = {
            id: existingSoldToId,
            code: existingSoldToCode,
            name: existingSoldToName
          }
          this.soldToList = [quoteSoldTo]
          this.$set(this.quoteData.basicInfo, 'selectedSoldTo', quoteSoldTo)
        }
      }
    },
  },
  created: async function() {
    console.log('ctlQuoteEdit created')
    // Load lookups - these don't depend on async data being ready
    this.getQuoteLookups({id: this.quoteData.basicInfo.facilityId, terr: this.quoteData.basicInfo.facilityTerritory})
    // SoldTo loading is handled by the watcher on 'quoteData.basicInfo.facilityAcctNo'
    // The watcher has immediate: true, so it will fire if the data is already available
  },
  mounted: function() {},
  destroyed: function() {
  }
};
</script>